/* ============================================
   NUT Botanicals - Promo Badges JS

   Keeps product-page promo badges as a stable overlay on the
   main media slider. Some slider initializations may move the
   badge into a slide/image wrapper; when that happens the badge
   can disappear after thumbnails load. This restores it back to
   the slider overlay without changing the badge design.
   ============================================ */

(() => {
  const BADGE_SELECTOR = '.nut-promo-badge';
  const SLIDER_SELECTOR = '.hdt-product-media__main .hdt-slider';

  const restoreBadgeOverlay = (slider) => {
    if (!slider || !slider.querySelectorAll) return;

    slider.querySelectorAll(BADGE_SELECTOR).forEach((badge) => {
      if (badge.parentElement !== slider) {
        slider.appendChild(badge);
      }
    });
  };

  const restoreAllBadges = () => {
    document.querySelectorAll(SLIDER_SELECTOR).forEach(restoreBadgeOverlay);
  };

  const boot = () => {
    restoreAllBadges();
    requestAnimationFrame(restoreAllBadges);
    window.setTimeout(restoreAllBadges, 300);
    window.setTimeout(restoreAllBadges, 1200);

    if (!document.body || !window.MutationObserver) return;

    const observer = new MutationObserver((mutations) => {
      let shouldRestore = false;

      for (const mutation of mutations) {
        if (mutation.type !== 'childList') continue;

        mutation.addedNodes.forEach((node) => {
          if (shouldRestore || !node.querySelectorAll) return;
          if (
            node.matches?.(BADGE_SELECTOR) ||
            node.matches?.(SLIDER_SELECTOR) ||
            node.querySelector?.(BADGE_SELECTOR) ||
            node.querySelector?.(SLIDER_SELECTOR)
          ) {
            shouldRestore = true;
          }
        });

        mutation.removedNodes.forEach((node) => {
          if (shouldRestore || !node.querySelectorAll) return;
          if (node.matches?.(BADGE_SELECTOR) || node.querySelector?.(BADGE_SELECTOR)) {
            shouldRestore = true;
          }
        });
      }

      if (shouldRestore) restoreAllBadges();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
